/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SimpleHealthRouteImport } from './routes/simple-health'
import { Route as RewardsRouteImport } from './routes/rewards'
import { Route as HealthRouteImport } from './routes/health'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as LoginCallbackRouteImport } from './routes/login/callback'

const SimpleHealthRoute = SimpleHealthRouteImport.update({
  id: '/simple-health',
  path: '/simple-health',
  getParentRoute: () => rootRouteImport,
} as any)
const RewardsRoute = RewardsRouteImport.update({
  id: '/rewards',
  path: '/rewards',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthRoute = HealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginCallbackRoute = LoginCallbackRouteImport.update({
  id: '/login/callback',
  path: '/login/callback',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/health': typeof HealthRoute
  '/rewards': typeof RewardsRoute
  '/simple-health': typeof SimpleHealthRoute
  '/login/callback': typeof LoginCallbackRoute
  '/login': typeof LoginIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/health': typeof HealthRoute
  '/rewards': typeof RewardsRoute
  '/simple-health': typeof SimpleHealthRoute
  '/login/callback': typeof LoginCallbackRoute
  '/login': typeof LoginIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/health': typeof HealthRoute
  '/rewards': typeof RewardsRoute
  '/simple-health': typeof SimpleHealthRoute
  '/login/callback': typeof LoginCallbackRoute
  '/login/': typeof LoginIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/health'
    | '/rewards'
    | '/simple-health'
    | '/login/callback'
    | '/login'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/health'
    | '/rewards'
    | '/simple-health'
    | '/login/callback'
    | '/login'
  id:
    | '__root__'
    | '/'
    | '/health'
    | '/rewards'
    | '/simple-health'
    | '/login/callback'
    | '/login/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HealthRoute: typeof HealthRoute
  RewardsRoute: typeof RewardsRoute
  SimpleHealthRoute: typeof SimpleHealthRoute
  LoginCallbackRoute: typeof LoginCallbackRoute
  LoginIndexRoute: typeof LoginIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/simple-health': {
      id: '/simple-health'
      path: '/simple-health'
      fullPath: '/simple-health'
      preLoaderRoute: typeof SimpleHealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rewards': {
      id: '/rewards'
      path: '/rewards'
      fullPath: '/rewards'
      preLoaderRoute: typeof RewardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health': {
      id: '/health'
      path: '/health'
      fullPath: '/health'
      preLoaderRoute: typeof HealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/callback': {
      id: '/login/callback'
      path: '/login/callback'
      fullPath: '/login/callback'
      preLoaderRoute: typeof LoginCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HealthRoute: HealthRoute,
  RewardsRoute: RewardsRoute,
  SimpleHealthRoute: SimpleHealthRoute,
  LoginCallbackRoute: LoginCallbackRoute,
  LoginIndexRoute: LoginIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
